<template>
  <div
    class="lead-time-wrapper"
    v-if="
      this.styleData[0] &&
        this.styleData[0].SAPDelivaryDate != '1/1/0001 12:00:00 AM'
    "
  >
    <div class="product-lead-time" @click="handleChatForAvailability()">
      <div class="leadtime-icon-wrapper" v-if="this.styleData[0].Icon">
        <img
          :style="iconColor"
          :class="leadTimeIcon"
          :src="this.styleData[0].Icon"
        />
      </div>
      <span :class="leadTimeMessage" v-html="displaymessage"></span>
    </div>
  </div>
</template>
<script>
import ProductOptionService from "../../services/ProductOptionService";
import { mapGetters } from "vuex";

export default {
  name: "ProductOptionsModal",
  props: {
    styleData: Array
  },
  data() {
    return {
      isbracket: false,
      MfProductUrl: null,
      mfquerystring: null,
      mfsku: null,
      qryvalue: null
    };
  },
  created() {
    // check query string
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const qrybracket = urlParams.get("bracket") ? urlParams.get("bracket") : "";

    if (qrybracket != "") {
      const [manufacturer, model] = qrybracket.split("|");
      this.qryvalue = qrybracket.toUpperCase();
      ProductOptionService.getMFnotes(
        manufacturer,
        model,
        this.getProductSku.SkuCode
      )
        .then(res => res.data)
        .then(products => {
          if (products.ProductUrl && products.RequiresProductCode) {
            this.MfProductUrl =
              products.ProductUrl != "#" ? products.ProductUrl : "";
            this.mfsku = products.ProductCode;
            this.qryvalue = products.RequiresProductCode;
            this.isbracket = true;
          } else {
            this.isbracket = false;
          }
        })
        .catch(() => {
          // to handle error
          this.MfProductUrl = null;
          this.mfsku = null;
          this.isbracket = false;
        });
    } else {
      return;
    }
  },
  computed: {
    ...mapGetters("product", ["getProductSku"]),
    ...mapGetters("addToCartCount", ["getValidCartCount", "getShowError"]),
    ...mapGetters("user", ["getIsUserLoggedIn"]),
    errorIconSrc() {
      return "https://res.cloudinary.com/avd/image/upload/v1661964419/Icons/New%20Design%20Site%20Icons/error.svg";
    },
    iconColor() {
      return "color:" + this.styleData[0].IconColor;
    },
    leadTimeIcon() {
      if (
        this.styleData[0].SAPStatusCode == 99 ||
        this.styleData[0].SAPStatusCode == 0
      ) {
        return "leadTimeIcon-Chat";
      } else {
        return "leadTimeIcon";
      }
    },
    leadTimeMessage() {
      if (
        this.styleData[0].SAPStatusCode == 99 ||
        this.styleData[0].SAPStatusCode == 98 ||
        this.styleData[0].SAPStatusCode == 86 ||
        this.styleData[0].SAPStatusCode == 0
      ) {
        return "lead-time-message-primary";
      } else {
        return "lead-time-message-secondary";
      }
    },
    isIE() {
      return window.navigator.userAgent.indexOf("Trident/") > -1;
    },
    getShipsInDate() {
      if (
        this.styleData[0].SAPDelivaryDate &&
        this.styleData[0].SAPStatusCode != 0 &&
        this.styleData[0].SAPStatusCode != 99 &&
        this.styleData[0].SAPStatusCode != 98 &&
        this.styleData[0].SAPStatusCode != 86
      ) {
        return this.FormatDate(this.styleData[0].SAPDelivaryDate);
      } else {
        return "";
      }
    },
    getUnitsToShip() {
      if (
        this.styleData[0].SAPDelivaryDate &&
        this.styleData[0].SAPStatusCode != 0 &&
        this.styleData[0].SAPStatusCode != 99 &&
        this.styleData[0].SAPStatusCode != 98 &&
        this.styleData[0].SAPStatusCode != 86 &&
        !this.getShowError
      ) {
        return `${this.getValidCartCount} unit(s)`;
      } else {
        return "";
      }
    },
    getUserRegionCodeToShip() {
      if (
        this.styleData[0].SAPDelivaryDate &&
        this.styleData[0].SAPStatusCode != 0 &&
        this.styleData[0].SAPStatusCode != 99 &&
        this.styleData[0].SAPStatusCode != 98 &&
        this.styleData[0].SAPStatusCode != 86 &&
        this.getIsUserLoggedIn
      ) {
        const userCookie = window.$cookies.get("WECO_user");
        const region =
          userCookie.REGIO != undefined ? userCookie.REGIO : userCookie.REGION;
        return `to ${region} on`;
      } else {
        return "";
      }
    },
    displaymessage() {
      return `${this.getUnitsToShip} ${this.styleData[0].Message} ${this.getUserRegionCodeToShip} <b>${this.getShipsInDate}</b>`;
    }
  },
  methods: {
    handleChatForAvailability() {
      if (
        this.styleData[0].SAPStatusCode == 99 ||
        this.styleData[0].SAPStatusCode == 0
      ) {
        const purecloudevent = new CustomEvent("loadpurecloudchat");
        document.body.dispatchEvent(purecloudevent);
      }
    },
    FormatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString("en-US", { month: "short" });
      const year = date.getFullYear()
      return `${month} ${day}, ${year}`;
    }
  },
  components: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.lead-time-wrapper {
  margin-bottom: 25px;
  @include media-breakpoint-up(sm) {
    margin-bottom: 0;
    border-bottom: 0;
  }
}
.product-lead-time {
  display: flex;
  margin: 16px 0 0px 0;
  align-items: center;
  @include media-breakpoint-down(xs) {
    align-items: unset;
  }

  .customLeadTimeIcon {
    margin: 8px 0 0 0;
  }

  .leadTimeIcon {
    font-size: 24px;
    margin-right: 8px;
    @include media-breakpoint-up(sm) {
      font-size: 28px;
      margin-right: 8px;
    }
  }

  .leadTimeIcon-Chat {
    font-size: 24px;
    margin-right: 8px;
    @include media-breakpoint-up(sm) {
      font-size: 28px;
      margin-right: 8px;
      cursor: pointer;
    }
  }
}

.lead-time-message-primary {
  color: $primary;
  font-family: $body;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0.2px;
  line-height: 24px;
  cursor: pointer;
}

.lead-time-message-secondary {
  color: $primary;
  font-family: $body;
  font-size: 16px;
  letter-spacing: 0.25px;
  line-height: 24px;
}

.option-required-product {
  @include hdg();
  @include body_small();
  display: flex;
  align-items: center;
  background-color: $warning-200;
  border: 1px solid $warning;
  min-height: 50px;
  padding-left: 16px;
  padding-right: 16px;
  min-width: 100%;
  margin-top: 8px;
  @media (min-width: $lg-tablet) {
    min-width: 100%;
    max-width: max-content;
  }
}

.required-product-link {
  text-decoration: underline;
  color: $primary;
  &:hover {
    color: $primary-300;
  }

  &:focus {
    color: $primary-300;
    @include focus_outline();
  }
}

.errorIcon {
  margin-right: 8px;
}
.non-icon-option-required-product-text {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 6px;
  margin-top: 6px;
  color: #262626;
}
.Mfnote-Padding {
  padding-bottom: 24px;
}
</style>
